import { request } from '@/shared/api/request'

export const getActualStaff = ({params}) => {
	return request({ url: 'staff/get/actual', method: 'GET', params: params })
}
